import { makeAutoObservable, runInAction } from 'mobx'
import { chatService, type ChatUnread } from '@/services/core/chat.service'

const EMPTY: ChatUnread = { total: 0, order: 0, direct: 0, group: 0 }

/**
 * What every chat surface shares: the unread badge (top bar, drawer tabs,
 * page tabs) and the right-hand drawer with the chat open in it. A read,
 * a sent message or a membership change calls `changed()` so the lists and
 * badges catch up at once instead of on their next poll.
 */
export class ChatStore {
  unread: ChatUnread = EMPTY
  drawerOpen = false
  /** The chat open inside the drawer; null shows the list. */
  drawerChatId: string | null = null
  /** Bumped on every local change; lists reload when it moves. */
  revision = 0

  constructor() {
    makeAutoObservable(this)
  }

  async refreshUnread() {
    try {
      const unread = await chatService.unreadCount()
      runInAction(() => {
        this.unread = { ...EMPTY, ...unread }
      })
    } catch {
      // The badge keeps its last value; the lists show real errors.
    }
  }

  changed() {
    this.revision += 1
    void this.refreshUnread()
  }

  openDrawer(chatId: string | null = null) {
    this.drawerOpen = true
    this.drawerChatId = chatId
  }

  showInDrawer(chatId: string | null) {
    this.drawerChatId = chatId
  }

  closeDrawer() {
    this.drawerOpen = false
  }
}
